import { TPatientFollowupDocument } from './use-patient-followup-documents.hook'
import { usePatientVariableDocument } from './use-patient-variable-document.hook'
import { useStandalonePatientVariableDocument } from './use-standalone-patient-variable-document.hook'

/**
 * Loads the file of a received document from the endpoint that serves it:
 * a file received through a form or a standalone one.
 */
const usePatientFollowupDocumentFile = (
  document: Pick<TPatientFollowupDocument, 'variableId' | 'patientFormId'>,
  patientId: string | number,
  projectId: string | number,
) => {
  const isStandaloneFile = document.patientFormId === null
  const formFile = usePatientVariableDocument(
    isStandaloneFile ? undefined : document.variableId,
    document.patientFormId ?? undefined,
    patientId,
    projectId,
  )
  const standaloneFile = useStandalonePatientVariableDocument(
    isStandaloneFile ? document.variableId : undefined,
    patientId,
    projectId,
  )

  return isStandaloneFile ? standaloneFile : formFile
}

export { usePatientFollowupDocumentFile }
